import React, {useEffect, useMemo, useState} from 'react';
import Translate from "../../../../../components/Translate";
import config from "../../../../../config";
import SearchInput from "../../../../../components-new/form/SearchInput";
import Template from "../../../../../components-new/general/Template";
import BlueButton from "../../../../../components-new/buttons/BlueButton";
import PlusIcon from "../../../../../assets/icons/PlusIcon";
import {addCustomTemplate} from "../../../../../services/company/api";

const CustomTemplates = ({
                             styles,
                             user,
                             setCustomTemplates,
                             deleteCustomTemplate,
                             editCustomTemplate,
                             customTemplates,
                             addNotification
                         }) => {

    const [search, setSearch] = useState('');

    const filteredTemplates = useMemo(() => {
            return customTemplates.filter(t =>
                t.text.toLowerCase().includes(search.toLowerCase())
            ).sort((a, b) => (b.id === null) - (a.id === null) || b.id - a.id) //nulls first
        },
        [search, customTemplates]);

    useEffect(() => {
        if (search !== '')
            removeNewTemplate()
    }, [search]);

    const handleSaveTemplate = (templateId, text) => {
        if (text.trim() === '') return;
        if (templateId) {
            editCustomTemplate(templateId, text);
            setCustomTemplates(customTemplates.map(template =>
                template.id === templateId
                    ? {...template, text}
                    : template
            ));
            addNotification('edited', config.notificationLevels.info)
        } else {
            addCustomTemplate(text).then(res => {
                setCustomTemplates([...customTemplates.filter(t => t.id !== null), res]);
            });
            addNotification('added', config.notificationLevels.success)
        }

    };

    const handleDeleteTemplate = (customTemplateId) => {
        if (customTemplateId === null) {
            removeNewTemplate();
            return
        }
        deleteCustomTemplate(customTemplateId);
        addNotification('deleted', config.notificationLevels.info)
    };

    const addTemplate = () => {
        setSearch('');
        if (!customTemplates.some(template => template.id === null)) {
            setCustomTemplates([{id: null, text: '', isNew: true}, ...customTemplates]);
        }
    }

    const removeNewTemplate = () => {
        setCustomTemplates(customTemplates.filter(t => t.id !== null));
    }

    return (
        <div className="custom-templates" style={{...styles.fullWidthCard, maxHeight: '100%'}}>

            <div className="custom-templates__toolbar">
                <div className="custom-templates__search">
                    <SearchInput
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        style={{width: '100%', height: '36px'}}
                    />
                </div>
                <BlueButton
                    variant="soft"
                    width="auto"
                    height="36px"
                    styles={{padding: '0 14px'}}
                    onClick={addTemplate}
                >
                    <PlusIcon width={18} height={18} stroke="currentColor"/>
                    <Translate text="addTemplate"/>
                </BlueButton>
            </div>

            <div className="custom-templates__list">
                {filteredTemplates.map((template) => (
                    <Template
                        key={template.id}
                        text={template.text}
                        onDelete={() => handleDeleteTemplate(template.id)}
                        onSave={(val) => handleSaveTemplate(template.id, val)}
                        defaultEditable={template.isNew}
                        onCancelEdit={() => template.id === null ? removeNewTemplate() : ''}
                        variant="management"
                    />
                ))
                }
                {
                    filteredTemplates.length === 0 &&
                    <div className="custom-templates__empty">
                        <Translate text="noTemplates"/>
                    </div>
                }
            </div>

        </div>
    );
};

export default CustomTemplates;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/my-history/components/CustomTemplates.jsx